module.exports = __webpack_public_path__ + "static/media/landscape_noseaspect.a3114a8f.jpg";